import { CapoPlugin } from "/home/runner/work/medicalclip-frontend/medicalclip-frontend/medicalclip-frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];